import { LocationQuestionConfig } from '@hyper-inferno/location-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';

export class LocationHandler implements QuestionHandler<LocationQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    return el.config;
  }
}